import api from '@mint-lib/api';
import { useQuery } from '@mint-lib/query-client';

import { MEDIA_PLAN_VERSIONS } from '../constants/EndpointConstants.js';
import { QueryKey } from '../constants/queryKeys.js';
import { VersionResponseSchema } from '../types/buyingPlanVersions.js';

const getVersion = async (versionId: number) => {
  const response = await api.get(`${MEDIA_PLAN_VERSIONS}${versionId}/`);
  return VersionResponseSchema.parse(response.data);
};

export const useGetVersionData = ({ versionId }: { versionId: number }) => {
  return useQuery({
    queryKey: [QueryKey.GET_VERSION, { versionId }],
    queryFn: () => getVersion(versionId),
    enabled: false,
  });
};
